.category-selector-wrapper {
  padding-bottom: 3rem;
  
  .content-area {
    margin: auto;
    max-width: 50rem;
    padding-top: 2.5rem;
    padding-bottom: .5rem;
    text-align: center;

    span { 
      @include text-size(32);
      @include line-height(40);
      color: $primary;
      font-weight: 800;
    }
  }
}

.kdx-category-selector {
  &__inner {
    width: 100%;
    margin: 0 auto;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      width: 15%;
      height: 100%;
      z-index: 2;
      left: 0;
      background: transparent linear-gradient(90deg, #F8F8F8 0%, #F8F8F8 50%, #F8F8F800 100%) 0% 0% no-repeat padding-box;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      width: 15%;
      height: 100%;
      z-index: 2;
      right: 0;
      background: transparent linear-gradient(270deg, #F8F8F8 0%, #F8F8F8 50%, #F8F8F800 100%) 0% 0% no-repeat padding-box;
    }
  }

  &.hide-pseudo-elements {
    .kdx-category-selector__inner {
      &::before { content: none; }
      &::after { content: none; }
    }
  }

  .kdx-carousel {
    margin: 0 auto;
    position: relative;

    .glide__slides { 
      margin: 0 auto; 
      padding-top: 20px;
      padding-bottom: 3rem;
    }

    .bullets-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      .bullet-Arrow {
        * {
          position: static !important;
        }

        &.controls {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
  
          button[data-glide-dir='<'], [data-glide-dir='>'] {
            display: none;
          }
        }
      }
      
    }

    .controls {
      top: 35%;
      width: 100%;
    }

    .glide__bullets {
      position: static;

      .glide__bullet {
        border-radius: 100%;
        padding: 0;
        height: 8px;
        width: 8px;
        border: none;
        background-color: #2D2D2D33;
        margin: 0 9.5px;
        box-shadow: none;
      }

      .glide__bullet--active {
        background-color: #2D2D2DCC;
      }
    }

    .controls button {
      background-color: #FFFFFF;
      background-image: none;
      padding: 0;
      height: 44px;
      width: 44px;
      border-radius: 50%;
      box-shadow: 0px 12px 22px #2D2F3B40;
      @include transitionDefault(all);
      z-index: 3;

      svg {
        @include svg-format(14px, 21px, $secondary);
      }

      &[disabled='true'] {
        opacity: 0.25;
        
        svg {
          fill: $gray-dark;
          transform: none;
        }
      }

      &[data-glide-dir='<'] {
      }

      &[data-glide-dir='>'] {
      }

      &:hover:not([disabled='true']) {
        background-color: $secondary;
        
        &[data-glide-dir='<'] {
          transform: translateX(-4px);
          transition: 0.3s ease-out;
        }

        &[data-glide-dir='>'] {
          transform: translateX(4px);
          transition: 0.3s ease-out;
        }

        svg {
          fill: white;
          transform: none;
        }
      }
    }
  }
}

.kdx-category {
  display: block; 
  padding: 16px;
  position: relative;
  text-decoration: none;
  border-radius: 10px;
  box-shadow: 0px 12px 22px #2D2F3B40;
  opacity: 1;
  background-color: #FFFFFF;


  .activeIcon {
    position: absolute;
    top: 15%;
    right: 9%;
    transform: translate(50%, -50%);
    max-height: 15px;
    width: 15px;
    display: none;
  }

  &.active {
    background: transparent;

  }

  &__icon {
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
    @include transitionDefault(all);
    padding: 44px 0 36px;

    img {
      height: auto;
      max-height: 46px;
      width: 100%;
    }
    svg {
      @include svg-format(34px, 32px, $secondary);
      transition: all 350ms;
    }
  }

  &__name {
    color: $secondary;
    display: block;
    font-weight: 600;
    position: relative;
    text-align: center;
    z-index: 2;
    overflow: hidden;
    word-wrap: break-word;
    border-top: 1px solid #ECEFF0;
    padding-top: 8px;
    @include text-size(20);
    @include line-height(30);
  }

}
a.kdx-category {
  &:hover {
    color: $secondary;
    transform: translateY(4px);
    transition: all 0.3s ease-out;
  
    .kdx-category {
      &__icon {
        transform: scale(1.5);
      } 
    }
  }
}

@media (max-width: 1365px) {
  .kdx-category-selector {    
    .kdx-carousel {
    }
  }
}

@include media-breakpoint-down(lg) {
  .category-selector-wrapper {
    .content-area {
      padding-top: 2.5rem;
    }
  }
}

@media (max-width: 960px) {
  .kdx-category-selector {
    &__inner { }
  }
}

@include media-breakpoint-down(md) {
  kdx-pageselector {
    max-width: 100%;
  }

  .category-selector-wrapper {
    .content-area {
      span {
        @include text-size(26);
        @include line-height(34);
      }
    }
  }
  .kdx-category-selector {
    &__inner {
      &::before, &::after {
        width: 5%;
      }
    }
  }
  .kdx-category {
    padding: 0.5rem;

    &__name {
      font-weight: 700;
      @include text-size(14);
      @include line-height(18);
    }
  }
}
